/**
 * G3 — item-ball pickup handler.
 *
 * Dispatch cadence (same as every tapped scriptRef): the tap shows the
 * DIALOGUE entry first ("You found a POTION!"); this handler fires on
 * dialogue CLOSE — grants the item, SETs the ball's FLAG_HIDE_* so
 * refreshNpcVisibility vanishes the sprite, plays the obtain jingle,
 * and saves (decision 20: setFlag does not autosave; handler-end save
 * is explicit).
 *
 * Re-fire safety: the hide flag doubles as the picked-up bit. A ball
 * whose flag is SET isn't rendered, so it can't be tapped — the flag
 * check here is a defensive no-op for the impossible double-dispatch,
 * not a reachable code path.
 */
import { ITEM_BALLS } from '../../data/items';
import type { Handler } from '../scriptRunner';

export const itemBallPickupHandler: Handler = (ctx, ref) => {
  const ball = ITEM_BALLS[ref];
  if (!ball) return;
  if (ctx.runState.hasFlag(ball.hideFlag)) return;
  ctx.runState.addItem(ball.itemId);
  ctx.runState.setFlag(ball.hideFlag);
  ctx.worldScene.refreshNpcVisibility();
  ctx.audio.playSfx('item_get');
  ctx.worldScene.save();
};
